module.exports = __webpack_public_path__ + "static/media/empathy_brain.0b2356d8.webp";